module.exports = __webpack_public_path__ + "media/images/views/talent/benefit-hand-384de6ec393352bbe5f8f53e49a3632a.png";